import React, { Component } from "react";
import { Link } from "react-router-dom";

class MenuFinanceiro extends Component {
  render() {
    return (
      <li className="nav-item">
        <Link to="/financeiro/consulta" className="nav-link">
          <i className="link-icon fa fa-dollar" />
          <span className="menu-title">Financeiro</span>
          {/*<i className="menu-arrow" />*/}
        </Link>
        {/*
        <div className="submenu">
          <ul className="submenu-item">
            <li className="nav-item">
              <Link className="nav-link" to="/financeiro/categoria/consulta">
                Consultar Categorias
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/financeiro/categoria/cadastro">
                Nova Categoria
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/financeiro/lancamento/consulta">
                Consultar Lançamentos
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/financeiro/lancamento/cadastro">
                Novo Lançamento
              </Link>
            </li>
          </ul>
        </div>
        */}
      </li>
    );
  }
}

export default MenuFinanceiro;
